export const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}.${month}.${day}`;
};

export const calculateDaysDifference = (startDate: string): number => {
  const start = new Date(startDate.replace(/\./g, '-') + 'T00:00:00');
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const timeDiff = today.getTime() - start.getTime();
  return Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
};

export const isToday = (dateString: string): boolean => {
  const today = formatDate(new Date());
  return dateString === today;
};

export const generateCalendarDays = (startDate: string): { date: string; hasStamp: boolean; isToday: boolean; isDisabled: boolean }[] => {
  const start = new Date(startDate.replace(/\./g, '-') + 'T00:00:00');
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = [];
  
  for (let i = 0; i < 100; i++) {
    const currentDate = new Date(start);
    currentDate.setDate(start.getDate() + i);
    currentDate.setHours(0, 0, 0, 0);
    const formattedDate = formatDate(currentDate);
    
    days.push({
      date: formattedDate,
      hasStamp: false,
      isToday: isToday(formattedDate),
      isDisabled: currentDate > today
    });
  }
  
  return days;
};